import styles from "./ButtonDivider.module.css";

function ButtonDivider({ text }) {
  return <div className={styles.divider}>{text}</div>;
}

export default ButtonDivider;
